import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { map } from 'lodash';
import { Bus, SiteConfigManager, useApplicationState, useSettings } from '@apollo/core';
import { COMPONENT_TYPES } from '@apollo/routing';
import HeaderInfoAuthorizedBalance from './HeaderInfoAuthorizedBalance';
import Label from '../../I18n/Label';
import { getClientProfileTabs } from '../../../../core/utils';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const onLogOut = () => {
  Bus.emit(Bus.events.auth.logout);
};

const MyAccountLinks = () => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const { layout } = useApplicationState();

  const { isBalanceHidden } = useSettings();

  const tabs = getClientProfileTabs();

  const onClickHandler = useCallback(() => {
    if (layout.mobileDevice) {
      Bus.send({
        event: Bus.events.layout.setMainMenu,
        data: false,
      });
    }
  }, [layout]);

  return (
    <div className='header__menu__items'>
      <div className='header__menu__title'>
        <Label message='My Account' />
      </div>
      {map(tabs, ({ name, link }) => (
        <NavLink
          key={link}
          to={`${clientProfilePath}/${link}`}
          className='header__menu__item header__menu__item--sub'
          activeClassName='active'
          onClick={onClickHandler}
        >
          <Label message={name} />
        </NavLink>
      ))}

      <div onClick={onLogOut} className='header__menu__item header__menu__item--sub text-danger'>
        <Label message='logout' />
      </div>
      {!isBalanceHidden && <HeaderInfoAuthorizedBalance />}
    </div>
  );
};

export default MyAccountLinks;
